import { Container, Nav, Navbar } from "react-bootstrap"
import { Link, Outlet, useNavigate } from "react-router-dom"
import { useAuth } from "../../Auth"
import { Login } from "../Admin/Login"
import { useEffect, useState } from "react"
import { HouseFill } from "react-bootstrap-icons"

export const TemplateAdmin: React.FC = () => {
	let auth = useAuth();
	let nav=useNavigate()

	const [iniciado, setIniciado] = useState(false)

	useEffect(() => {
		if (!auth.user) {
			//let token = document.querySelector("body")?.getAttribute("data-token") || "";
			let token = localStorage.getItem("token")
			if (token && token !== "") {
				auth.login("", "", token, (success: boolean) => {
					setIniciado(true)
				})
			}
			else {
				setIniciado(true)
			}
		}
		else {
			setIniciado(true)
		}
		// eslint-disable-next-line
	}, [])

	return <>
		<Navbar variant="dark" expand="sm" bg="dark" collapseOnSelect className="py-2">
			<Container fluid>
				{/*<Navbar.Brand href="/espsystem" className="m-0 p-0 ps-4"><Image src="https://www.educa.saludpublica.uchile.cl/espsystem/images/v4/log_esp.png" height={40}/></Navbar.Brand>*/}
				<Navbar.Brand as={Link} to="/admin" className="m-0 p-0"><HouseFill /> Sistema de Gestión de Contenido</Navbar.Brand>
				<Navbar.Toggle />
				<Navbar.Collapse>
					<Nav className="ms-auto pe-4 text-white">
						{auth.user && <Nav.Link onClick={()=>auth.logout(()=>{nav("/admin")})} >Cerrar Sesión</Nav.Link>}
					</Nav>
				</Navbar.Collapse>
			</Container>
		</Navbar>
		<Container fluid>
			{iniciado && <>
				{auth.user && <Outlet />}
				{!auth.user && <Login />}
			</>}
		</Container>
	</>
}